<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <bread-crumb></bread-crumb>
        </div>
        <el-card class="el-main">
            <div slot="header">
                <el-tabs class="devicetabs" v-model="activeName">
                    <el-tab-pane label="充值订单" name="0" ></el-tab-pane>
                    <el-tab-pane label="退款记录" name="1" ></el-tab-pane>
                    <el-tab-pane label="消耗记录" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <charge-card-recharge-list v-if="activeName == '0'" :id='userCardId' :userId='userId' :cardBalance='cardBalance'></charge-card-recharge-list>
            <charge-card-refund-list v-if="activeName == '1'" :id='userCardId' :userId='userId' :cardBalance='cardBalance'></charge-card-refund-list>
            <charge-card-use-list v-if="activeName == '2'" :id='userCardId' :userId='userId' :cardBalance='cardBalance'></charge-card-use-list>
        </el-card>
    </div>
</template>

<script>
import chargeCardRechargeList from './child/chargeCard-recharge-list.vue'
import ChargeCardRefundList from './child/chargeCard-refund-list.vue'
import ChargeCardUseList from './child/chargeCard-use-list.vue'
    export default {
        components: { chargeCardRechargeList, ChargeCardRefundList, ChargeCardUseList },
        data () {
            return {
                activeName: '0',
                userCardId: this.$route.query.userCardId,
                userId: this.$route.query.userId,
                cardBalance: this.$route.query.cardBalance,
            }
        },
        created () {
            console.log( this.$route.query.cardBalance, this.cardBalance);
        },
        methods: {
            
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-card__header{
        padding: 0 20px;
    }
    /deep/ .el-tabs__item {
        // color: #007aff;
        font-size: 14px;
    }

    /deep/ .el-tabs__item.is-active {
        color: #007AFF;
        font-weight: bold;
    }

    /deep/ .el-tabs__nav-wrap::after {
        background: none !important;
    }

    /deep/ .el-tabs__header {
        background: #fff;
    }
</style>